import * as React from 'react';
import AntLayout from 'antd/lib/layout';

import {
    Props
} from 'one-ui';

export const Layout = ({
    style,
    children,
    className,
}: Props) => (
        <AntLayout
            style={style}
            className={className}
        >
            {children}
        </AntLayout>
    );
